import React from 'react';
import { Link } from 'react-router-dom';
import { BRAND_NAME } from '@/utils/branding';

// Single source of truth for footer links. Targets are placeholder pages
// until real content / external destinations are decided.
const FOOTER_COLUMNS: { heading: string; links: { label: string; to: string }[] }[] = [
  {
    heading: 'Product',
    links: [
      { label: 'Features', to: '/features' },
      { label: 'Security', to: '/security' },
    ],
  },
  {
    heading: 'Company',
    links: [
      { label: 'Privacy', to: '/privacy' },
      { label: 'Terms', to: '/terms' },
    ],
  },
];

// Placeholder tagline - swap once final copy is decided.
const TAGLINE = 'Enterprise knowledge intelligence for the modern organisation.';

/**
 * Shared footer for standalone/public pages (error pages, legal placeholders,
 * future landing page). NOT rendered inside the dashboard app shell.
 */
export const SiteFooter: React.FC = () => {
  return (
    <footer className="relative z-10 border-t border-border bg-card/40">
      <div className="max-w-6xl mx-auto px-6 sm:px-10 py-10 grid grid-cols-1 sm:grid-cols-[1.4fr_1fr_1fr] gap-8">
        <div>
          <div className="text-xl font-semibold tracking-tight">{BRAND_NAME}</div>
          <p className="mt-3 text-sm leading-relaxed text-muted-foreground max-w-[340px]">
            {TAGLINE}
          </p>
        </div>
        {FOOTER_COLUMNS.map((col) => (
          <div key={col.heading}>
            <div className="text-sm font-medium text-muted-foreground mb-3">{col.heading}</div>
            <ul className="space-y-2">
              {col.links.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-foreground/90 hover:text-primary transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </footer>
  );
};

export default SiteFooter;
